import ServiceBase from './ServiceBase';

export default class EmrVendorService extends ServiceBase {
    async getVendors() {
        var results = await this.requestJson({
            url: "api/admin/emrvendor",
            method: "GET"
        });

        return results;
    }

    async getVendor(id) {
        var result = await this.requestJson({
            url: `api/admin/emrvendor/${id}`,
            method: "GET"
        });

        return result;
    }

    async saveVendor(vendor) {
        var result = await this.requestJson({
            url: `/api/admin/emrvendor`,
            method: "POST",
            data: vendor
        });

        return result;
    }
}